<template>
  <div id='ae' class='' v-loading='loading'>
  
    <div class='gPageBorder'>
      <div style='width:140px;height:140px;margin:24px 24px 24px 24px;display:inline-block;float:left;overflow:hidden;'>
      
      </div><div style='display:inline-block;width:calc(100% - 188px);height:100%;margin-bottom:0px;:'>
        <div style='height:64px;'>
          <button class='dt-word-main' style='padding:0;height:100%;font-size:22px;background:none;border:none;'>{{config ? config.data.appName : ''}}</button>
        </div>
        <div style='height:60px;'>
          <table class='dt-app'>
            <tr>
              <td>
                <label class='dt-word-title'>{{$t('app_version')}}：</label>
                <label class='dt-word-main'>{{config? config.data.appVersion : ''}}</label>
              </td>
              <td>
                <label class='dt-word-title'>{{$t('app_verTag')}}：</label>
                <label class='dt-word-main'>{{config? config.data.versioncode : ''}}</label>
              </td>
            </tr>
            <tr>
              <td>
                <label class='dt-word-title'>{{$t('app_appType')}}：</label>
                <label class='dt-word-main'>{{config.data.appCategoryName}}</label>
              </td>
              <td>
                <label class='dt-word-title'>{{$t('app_package')}}：</label>
                <label class='dt-word-main'>{{config? config.data.packagename : ''}}</label>
              </td>
              <!-- <td>
                <label class='dt-word-title'>{{$t('app_insType')}}：</label>
                <label class='dt-word-main'>{{setInstallType(config.data.appInstallType)}}</label>
              </td> -->
              <td></td>
            </tr>
          </table>
        </div>
        <div style='min-height:60px;display:flex;display:-webkit-flex;'>
          <div class='dt-word-title' style='display:inline-block;min-width:70px;'>
            {{$t('app_introl')}}：
          </div>
          <div class='dt-word-main' style='display:inline-block;position:relative;background:none;margin: 0 24px 24px 0;'>
            <pre>{{config.data.appDesc}}</pre>
          </div>
        </div>
      </div>
    </div>
     
    <div class='gPageBorder gTopMg' v-show='captures? captures.length > 0 : false'  style=''>
      
      <p class='gCtColor  gPTitle' style=''>{{$t('app_screenShot')}} </p>
      <div>
        <img onerror="this.src='/static/img/df-h.png'" v-for='item in captures' class='gBorder' style='width:180px;height:320px;margin:24px 0 24px 24px;border-radius:4px;' :src="imgFullUrl(item)">
      </div>
  
    </div>

    <div class='gPageBorder gTopMg' v-show='config.type === 2 && config.isHistory' style=''>
      
      <p class='gCtColor gPTitle' style=''>{{$t('app_hisVer')}} </p>

      <el-button  v-show="showUploadNew"  @click='uploadNew' type='primary' style='margin: 24px 0 24px 24px' class=''>{{$t('app_ulNew')}}</el-button>
      
      <el-table
        :data="tableData"
        border
        style="width: 100%;">
        <el-table-column
          header-align='center'
          align='center'
          prop="appName"
          :label="$t('app_appName')"
          width="">
        </el-table-column>
        <el-table-column
          header-align='center'
          align='center'
          prop="appVersion"
          width=''
          :label="$t('app_version')">
        </el-table-column>
        <el-table-column
          header-align='center'
          align='center'
          prop="appCategoryName"
          width=''
          :label="$t('app_type')">
        </el-table-column>
      
        <el-table-column
          header-align='center'
          align='center'
          :formatter="dateFormat"
          prop="createTime"
          width='170'
          :label="$t('app_createTime')">
        </el-table-column>
        <el-table-column
          header-align='center'
          align='center'
          prop=""
          width='90'
          :label="$t('app_operate')">
          <template slot-scope='scope'>
            

            <!-- <el-button v-show="scope.row.appStatus !== '1' && scope.row.appStatus !== '2'" @click='submitApp(scope.row)' type='text'>{{$t('app_smVerify')}}</el-button> -->

            <!-- <el-button v-show="config.data.isoperation === 0" type=text @click='deleteAppHis(scope.row)'>{{$t('app_del')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top">
              <el-button type='text' v-show="config.data.isoperation === 0" @click='deleteAppHis(scope.row)'><i class="fa fa-trash-o" style="color:#FF4949"></i></el-button>
            </el-tooltip>

          </template>
        </el-table-column>
      </el-table>
    </div>
  

  </div>
</template>

<style>
  .dt-word-main{color:rgb(72,87,106)}
  .dt-word-title{color:#99A9BF;}
  pre{
    white-space: pre-wrap;
    word-wrap: break-word;
    white-space: -moz-pre-wrap;
    white-space: -pre-wrap;
    white-space: -o-pre-wrap;
    word-break:break-all;
  }

  .dt-app{width:100%;height:100%;}
    .dt-app td{width:50%;}

  /* upload */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .capture {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width:120px;
    display:inline-block;
  }
  .capture div{float:left;}

  .avatar-uploader .el-upload:hover {
    border-color: #20a0ff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 128px;
    height:128px;
    line-height: 128px;
    text-align: center;
  }

  /* upload */
  .sm-avatar-uploader-icon {
    font-size: 36px;
    color: #8c939d;
    width: 72px;
    height:72px;
    line-height: 72px;
    text-align: center;
  }
  .sm-avatar {
    width: 64px;
    height: 64px;
    display: block;
  }
 
</style>

<script>
  import mm from 'moment'
  export default {
    data () {
      return {
        config: '',
        captures: [],
        loading: 0
      }
    },
    computed: {
      avtStyle () {
      },
      showUploadNew () {
        console.log('ccc', this.config.data)
        if (this.config.data) {
          if (this.config.data.isoperation === 0 && this.config.data.appStatus === '2') {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      }
    },
    methods: {

      setInstallType (type) {
        return this.$installType[type]
      },
      dateFormat (row, column) {
        var date = row[column.property]
        if (date === undefined) {
          return ''
        }
        return mm(date).format('YYYY-MM-DD hh:mm:ss')
      },
      selectChange (vl) {
        this.getDevices()
      },
      pageSelect (index) {
        this.index = index
        this.getDevices()
      },
      pageSized (val) {
        this.$gRow = val
        this.getDevices()
      },
     


      deleteAppHis (row) {
        // console.log(row)
        if (row.applicationid) {
          this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
            confirmButtonText: this.$t('app_sure'),
            cancelButtonText: this.$t('app_cancel'),
            type: 'warning'
          }).then(() => {
            this.loading = 1
            if (this.$appUrlTag === 0) {
              this.$deleteApp(row.applicationid, (res) => {
                this.loading = 0
                if (res.status === 200) {
                  this.getAppHistory()
                } else {
                  this.$message.error(res.message)
                }
              }, () => {
                // error
                this.loading = 0
              })
            } else {
              this.$deleteAppHis(row.applicationid, (res) => {
                this.loading = 0
                if (res.status === 200) {
                  this.getAppHistory()
                } else {
                  this.$message.error(res.message)
                }
              }, () => {
                // error
                this.loading = 0
              })
            }
          }).catch(() => {
          })
        }
      },
 
      imgFullUrl (path) {
        if (path) {
          // return this.$host + path
          // console.log('imgpath', path, this.$urls.prefix + path)
          return this.$urls.prefix + path
        } else {
          return ''
        }
      },

      getAppHistory () {
        if (!this.config.data.appName) {
          return
        }
        // console.log('pkg', this.config.data)
        this.loading = 1
        if (this.$appUrlTag === 0) {
          this.$getAppHistory(this.config.data.appName, this.config.data.packagename, (res) => {
            //console.log('his', res)
            //alert(res)
            this.loading = 0
            if (res.status === 200) {
              this.tableData = res.data
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            // error
            this.loading = 0
          })
        } else {
          
          this.$getAppHistory1(localStorage.mechanismId, this.config.data.packagename, (res) => {

            console.log('his', res)
            this.loading = 0
            if (res.status === 200) {
              this.tableData = res.data
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            // error
            this.loading = 0
          })
        }
        
      },
      uploadNew () {
        // this.config = {type: 4, data: this.config}
        // /newversion 
        //this.$router.push({name: this.$t('menu.appManageSub.uploadNew')})
        this.$router.push({path: '/applist/newversion'})
      },
      init () {
        this.config = this.$getWObj().editAppConfig
        this.setCapturesArr(this.config.data.appScreenShot)
        this.getAppHistory()
        console.log(this.config)
      },
      setCapturesArr (strs) {
        if (strs) {
          var arr = strs.split(',')
          this.captures = arr
        }
      }
    },
    mounted () {
      this.init()
    }
  }
</script>



// WEBPACK FOOTER //
// edit.vue?666f9278